import { defineActions } from './defineActions'

/**
 * Attendance and on hold. Action names start with Attendance.
 *
 * The footer Save of the section (and the Save of the Specialist Dashboard "Update Attendance
 * Status" modal, which runs the same save) is the page action Ime.Attendance.Save (ime-page.ts).
 */
export const attendanceActions = defineActions({
  'Attendance.Reminder.SendToSpecialist': {
    label: 'Send Attendance Update Reminder',
    area: 'Attendance',
  },
  'Attendance.ReschedulingReminder.ResendToStaff': {
    label: 'Resend rescheduling reminder to Staff PIC',
    area: 'Attendance',
  },
  'Attendance.ReschedulingReminder.ResendToBookingCm': {
    label: 'Resend rescheduling reminder to Booking CM',
    area: 'Attendance',
  },
})
